import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize',
  standalone: true
})
export class FileSizePipe implements PipeTransform {
  transform(size: number): string {
    if (!size) {
      return '0 Bytes';
    }

    const bytesInKilobyte: number = 1024;
    const sizeUnits: string[] = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const sizeUnitIndex: number = Math.floor(Math.log(size) / Math.log(bytesInKilobyte));

    const formattedSize: string = (size / Math.pow(bytesInKilobyte, sizeUnitIndex)).toFixed(2);

    return `${formattedSize} ${sizeUnits[sizeUnitIndex]}`;
  }
}
